var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var RenderPrimitive = /** @class */ (function () {
    function RenderPrimitive(id, primitiveType, primitiveProps, printable) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "primitiveType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "primitiveProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "printable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = id;
        this.primitiveType = primitiveType;
        this.primitiveProps = primitiveProps;
        this.printable = !!printable;
    }
    Object.defineProperty(RenderPrimitive.prototype, "move", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var x = _a.x, y = _a.y;
            switch (this.primitiveType) {
                case 'rect':
                case 'circle':
                case 'pxc_logo':
                    this.primitiveProps = movePoint(x, y, this.primitiveProps);
                    break;
                case 'polygon':
                case 'polyline':
                    this.primitiveProps = movePolygon(x, y, this.primitiveProps);
                    break;
                case 'line':
                    this.primitiveProps = moveLine(x, y, this.primitiveProps);
                    break;
                case 'arc':
                    this.primitiveProps = moveArc(x, y, this.primitiveProps);
                    break;
                case 'text':
                    this.primitiveProps = moveText(x, y, this.primitiveProps);
                    break;
            }
            return this;
        }
    });
    return RenderPrimitive;
}());
export default RenderPrimitive;
var movePoint = function (dx, dy, props) {
    return __assign(__assign({}, props), { x: dx + props.x, y: dy + props.y });
};
var moveText = function (dx, dy, props) {
    return __assign(__assign({}, props), { position: movePoint(dx, dy, props.position) });
};
var moveLine = function (dx, dy, props) {
    return __assign(__assign({}, props), { start_point: movePoint(dx, dy, props.start_point), end_point: movePoint(dx, dy, props.end_point) });
};
var moveArc = function (dx, dy, props) {
    return __assign(__assign({}, props), { start_point: movePoint(dx, dy, props.start_point), point_on_the_arc: movePoint(dx, dy, props.point_on_the_arc), end_point: movePoint(dx, dy, props.end_point) });
};
var movePolygon = function (dx, dy, props) {
    var points = props.points;
    var changedPoints = [];
    for (var i = 0; i < points.length; i++) {
        var newValue = i % 2 === 0 ? dx : dy;
        changedPoints.push(points[i] + newValue);
    }
    return __assign(__assign({}, props), { points: changedPoints });
};
